import httpService from "../httpService";

export default {
  findByHcQuyCheQuyDinhId(hcQuyCheQuyDinhId) {
    let params = {hcQuyCheQuyDinhId: hcQuyCheQuyDinhId};
    return httpService.get("/hcQuyCheQuyDinhUser/findByHcQuyCheQuyDinhId", {
      params: params
    });
  }
};



// WEBPACK FOOTER //
// ./src/services/quychequydinh/hcQuyCheQuyDinhUserService.js